/**
 * CustomEvent creation with an IE11-safe fallback.
 *
 * The bootstrap dispatch in index.ts runs at module load - before any
 * Telemetry/Sentry exists and outside the app's try/catch - so a missing
 * CustomEvent *constructor* (IE11) would throw uncaught and silently prevent the
 * whole library from initialising, with nothing reported. IE11 does support the
 * legacy document.createEvent('CustomEvent') + initCustomEvent path, so we fall
 * back to it when the constructor is unavailable.
 */
export function createCustomEvent(name: string, detail: any) : CustomEvent {
    // Preferred: the standard constructor. A single try/catch covers every failure
    // mode in one place - missing, not constructable (old browsers), or a broken
    // polyfill that throws - and the common (modern) path throws nothing.
    try {
        return new CustomEvent(name, { detail: detail });
    } catch (error) {
        // surface why we're degrading, then fall back to the legacy API
        console.debug('fountain-analytics: CustomEvent constructor unavailable, using legacy event API', error);
    }
    // legacy fallback (IE11 and old browsers)
    // initCustomEvent(type, bubbles, cancelable, detail)
    const event = document.createEvent('CustomEvent');
    (event as any).initCustomEvent(name, false, false, detail);
    return event as CustomEvent;
}
